export default ({ request }) => ({
  ecomAmzFtyNoticeInListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/del',
      method: 'POST',
      data,
    })
  },

  ecomAmzFtyNoticeInSendWarehouseApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/sendWarehouse',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInConfirmCarrierApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/confirmCarrier',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInAdjustApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/adjust',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeInCancelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/in/cancel',
      method: 'POST',
      data,
    })
  },
})
